import { getChannelAPIPath } from '@treasury/core/http';

TranGroupCodeService.$inject = ['$resource', '$http', '$q'];

export default function TranGroupCodeService($resource, $http, $q) {
    return {
        get,
    };

    function get() {
        return $resource(
            `${getChannelAPIPath()}transactioncodegroup/`,
            {},
            {
                getAll: { method: 'get', isArray: true },
            }
        ).getAll().$promise;
    }
}
